import defaultsDeep from 'lodash/defaultsDeep';
import { getGenericChartConfig } from 'JIX/highcharts/configs/generic_chart.js';

const PADDING = 15;
const MAXHEIGHT = 600;

// Handles the logic and calculations for setting the height
// of the chart and vertical scroll. If enableScroll is false
// the chart height is either set to the userdefined height
// or calculated based on the number of datapoints and the pointWidth.
// If the chart has no data, the height of the chart is set to
// the Highcharts default.
function handleHeightAndScroll(chart, enableScroll) {
    const pointWidth = chart.getOptions().plotOptions.bar.pointWidth;
    const n_data = Math.max(...chart.getOptions().series.map((arr) => arr.data.length));
    const overlay_height = chart.chartHeight - chart.plotHeight;
    const chart_height = ((pointWidth + PADDING) * n_data || chart.plotHeight) + overlay_height;

    if (enableScroll) {
        chart.update({
            chart: {
                // Maintains a maximum chart height of {MAXHEIGHT}px.
                height: Math.min(chart_height, MAXHEIGHT),
                scrollablePlotArea: {
                    // When the height of the chart is less than the height
                    // of the plotarea, the plotarea becomes scrollable to
                    // maintain the visuals and overview of the chart.
                    minHeight: chart_height,
                },
            },
            tooltip: {
                followPointer: true,
            },
        });
    } else {
        chart.update({
            chart: {
                height: chart.getOptions().chart.height || chart_height,
            }
        });
    }
}

export function getStandardBarChartConfig(options = {}, enableScroll = true) {
    const default_config = getGenericChartConfig({
        title: {
            text: "Bar Chart",
        },
        chart: {
            type: 'bar',
            events: {
                load: function() {
                    handleHeightAndScroll(this, enableScroll);
                },
            },
        },
        xAxis: {
            tickWidth: 1,
        },
        yAxis: {
            title: {
                align: 'high',
            },
        },
        // To affect the size of the plotarea when calling
        // this function, override pointWidth in plotOptions.
        // To only affect the width of the bars themselves, override
        // pointWidth in the specific series.
        plotOptions: {
            bar: {
                pointWidth: 20,
            },
        },
    });

    // Mutates 'options' with any 'default_config' options
    // that are missing from 'options'
    defaultsDeep(options, default_config);

    return options;
}
